import React from 'react';
import classnames from 'classnames';

import './style.scss';

const PREFIX = 'music';

export type IconStyle = 
  | 'Collapse' | 'Expand' | 'Next' | 'Close' | 'Edit' | 'Sort' | 'Delete' | 'Tick'
  | 'Info' | 'Calendar' | 'Upload' | 'UploadBig' | 'Ai' | 'Album' | 'Music' | 'MusicBig'
  | 'User' | 'Home' | 'HomeLine' | 'MySongs';

export interface IconProps {
  style?: IconStyle;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  onClick?: () => void;
  color?: string;
}

// SVG 路径定义
const ICON_PATHS: Record<IconStyle, React.ReactNode> = {
  Collapse: (
    <path d="M6.03 9.53a.75.75 0 0 1-1.06-1.06l6.5-6.5a.75.75 0 0 1 1.06 0l6.5 6.5a.75.75 0 1 1-1.06 1.06L12 3.56l-5.97 5.97z" fill="currentColor" />
  ),
  Expand: (
    <path d="M17.97 14.47a.75.75 0 1 1 1.06 1.06l-6.5 6.5a.75.75 0 0 1-1.06 0l-6.5-6.5a.75.75 0 1 1 1.06-1.06L12 20.44l5.97-5.97z" fill="currentColor" />
  ),
  Next: (
    <path d="M14.47 6.03a.75.75 0 0 1 1.06 1.06l-6.5 6.5a.75.75 0 0 1-1.06 0l-6.5-6.5a.75.75 0 0 1 1.06-1.06L8.5 12l5.97-5.97z" fill="currentColor" transform="rotate(90 12 12)" />
  ),
  Close: (
    <path d="M18.3 5.71a1 1 0 0 0-1.42 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z" fill="currentColor" />
  ),
  Edit: (
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor" />
  ),
  Sort: (
    <path d="M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z" fill="currentColor" />
  ),
  Delete: (
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="currentColor" />
  ),
  Tick: (
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor" />
  ),
  Info: (
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="currentColor" />
  ),
  Calendar: (
    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z" fill="currentColor" />
  ),
  Upload: (
    <path d="M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5v-2z" fill="currentColor" />
  ),
  UploadBig: (
    <path d="M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5v-2z" fill="currentColor" />
  ),
  Ai: (
    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" fill="none" strokeWidth="2" />
  ),
  Album: (
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z" fill="currentColor" />
  ),
  Music: (
    <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" fill="currentColor" />
  ),
  MusicBig: (
    <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" fill="currentColor" />
  ),
  User: (
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="currentColor" />
  ),
  Home: (
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" fill="currentColor" />
  ),
  HomeLine: (
    <path d="M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z" fill="currentColor" />
  ),
  MySongs: (
    <path d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z" fill="currentColor" />
  ),
};

export default function Icon({ style = 'Music', size = 'medium', className, onClick, color }: IconProps) {
  const sizeMap = {
    small: 16,
    medium: 24,
    large: 32,
  };

  const iconSize = sizeMap[size];

  return (
    <svg
      className={classnames(`${PREFIX}-icon`, `${PREFIX}-icon--${size}`, className)}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ color }}
    >
      {ICON_PATHS[style]}
    </svg>
  );
}
